import { required, validEmail } from 'services/validators'
import { isValidPhoneNumber } from 'react-phone-number-input'

const brokerClient = values => {
  const errors = {}
  if (!required(values.name)) {
    errors.name = 'Nombre requerido'
  }
  if (!required(values.firstName)) {
    errors.firstName = 'Nombre requerido'
  }
  if (!required(values.lastName)) {
    errors.lastName = 'Apellido requerido'
  }
  if (!required(values.street)) {
    errors.street = 'Calle requerida'
  }
  if (!required(values.streetNumber)) {
    errors.streetNumber = 'Número exterior requerido'
  }
  if (!required(values.state)) {
    errors.state = 'Estado requerido'
  }
  if (!required(values.neighborhood)) {
    errors.neighborhood = 'Colonia requerida'
  }
  if (!required(values.district)) {
    errors.district = 'Municipio requerido'
  }
  if (!required(values.city)) {
    errors.city = 'Ciudad requerida'
  }
  if (!required(values.email)) {
    errors.email = 'Email requerido'
  } else if (!validEmail(values.email)) {
    errors.email = 'Email inválido'
  }
  if (!required(values.telephone)) {
    errors.telephone = 'Teléfono requerido'
  } else if (!isValidPhoneNumber(values.telephone)) {
    errors.telephone = 'Teléfono inválido'
  }

  if (
    required(values.secondTelephone) &&
    !isValidPhoneNumber(values.secondTelephone)
  ) {
    errors.secondTelephone = 'Teléfono inválido'
  }
  if (required(values.mobilePhone) && !isValidPhoneNumber(values.mobilePhone)) {
    errors.mobilePhone = 'Teléfono inválido'
  }
  if (
    required(values.secondMobilePhone) &&
    !isValidPhoneNumber(values.secondMobilePhone)
  ) {
    errors.secondMobilePhone = 'Teléfono inválido'
  }

  return errors
}

export default brokerClient